import { ButtonRow, DangerButton } from '../../../styles';
import { ModalShell } from '../styles';

// Mirrors legacy v1 `ExitJobEditorModal` (CreateGigOrder/JobEditor/modals)
// — that modal pops when the user clicks the close affordance after
// progressing past the first step, and warns "Your job creation
// changes will not be saved". v2 previously closed without any prompt
// so accidental clicks on the header X discarded in-progress data.

type ExitWizardModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const ExitWizardModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: ExitWizardModalProps) => {
  if (!isOpen) return null;

  return (
    <ModalShell role="dialog" aria-label="Exit job editor">
      <h4>Exit job editor</h4>
      <p>
        Are you sure you want to exit?{' '}
        <strong>Your job creation changes will not be saved.</strong>
      </p>
      <ButtonRow align="end">
        <button type="button" onClick={onCancel}>
          Keep editing
        </button>
        <DangerButton type="button" onClick={onConfirm}>
          Exit
        </DangerButton>
      </ButtonRow>
    </ModalShell>
  );
};

export default ExitWizardModal;
